<template>
  <DxPopup @hidden="onHidden" :visible="printPop" :show-close-button="true" :show-title="true" :title="'Print Page Control'" :height=window.heights :width=window.widths container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Print Item'"
                         :useBtnList="useBtnList"
                         @btnClose="btnClose()"
                         @btnPrintSheet="btnPrintSheet()"
        >
          <template v-slot:body>
            <v-row>
              <v-col cols="12" class="pa-0">
                <i-card-top
                    class="d-md-flex"
                    outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-0 pl-1">
                      <v-col cols="12">
                        <v-row dense>
                          <i-label :label="'Choose page : '"/>
                          <v-col cols="1">
                            <v-select
                                v-model="choosePage"
                                :items="pageList"
                                single-line
                                outlined
                                dense
                                @change="choosePageChange()"
                            ></v-select>
                          </v-col>
                          <i-label :label="'Insp.Place : '" class="pl-2"/>
                          <v-col cols="2">
                            <v-select
                                v-model="inspLoc"
                                :items="inspLocList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="doSearchMain()"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-1">
                <DxDataGrid id="v80o1020PrintPop"
                            :ref="v80o1020PrintPopRef"
                            :height= window.heightDx
                            :data-source="gridMainList"
                            :remote-operations="false"
                            :hover-state-enabled="true"
                            :allow-column-resizing="true"
                            :allow-column-reordering="true"
                            :row-alternation-enabled="true"
                            :show-borders="true"
                            :width="grid.width"
                            :show-row-lines="true"
                            key-expr="id"
                            :focused-row-enabled="false"
                            :column-hiding-enabled="false"
                            :word-wrap-enabled="true"
                            :selection="{mode:'none'}"
                >
                  <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="shipNo" caption="Ship No" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="porNoSeq" caption="POR NO" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false" v-if="blockYn"/>

                  <DxColumn data-field="itemDesc" caption="Item Inspection" width="30%" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="insDate" caption="Insp. Date" width="7%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="insTime" width="5%" data-type="string" alignment="center" :allow-editing="false"  header-cell-template="inspTime"/>
                  <template #inspTime >
                    <div>Insp.<br>Time</div>
                  </template>

                  <DxColumn data-field="kindNm" caption="Kind of Inspection" width="15%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porQty" caption="Qty" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="locNm" caption="Insp. Place" width="10%" data-type="string" alignment="center" :allow-editing="false" />

                  <DxPaging :enabled="true" :page-size="16" />
                  <DxPager :visible="true"  :showInfo="false" />
                </DxDataGrid>
                <span style="font-weight: bold;">Count Total: {{ totalRow }} Row(s)</span>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { v80oPrintList } from '@/api/view/hip/8/v80o1020Popup.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { reportView} from '@/api/view/hip/common/common.js'

export default {
  name: 'v80o1020PrintPop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxDateBox,
    DxLookup
  },
  props: {
    printPop: {
      type: Boolean,
      default() { return false }
    },
    popupData: {
      type: Array,
      default() { return }
    },
    pageListPop: {
      type: Array,
      default() { return }
    },

  },
  data() {
    return {
      useBtnList: ['btnPrintSheet','btnClose'],
      v80o1020PrintPopRef: 'v80o1020PrintPopRef',
      gridMainList: [],
      totalRow: 0,

      choosePage: '1',
      pageList: this.pageListPop,

      inspLoc: '',
      inspLocList:[],

      blockYn: false,
      setPorNoseq: '',

      window: {
        widths: 0,
        heights: 0,
        heightDx: 0
      }

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80o1020PrintPopRef)
    },
  },
  watch: {
    'printPop': {
      handler(value, oldValue) {
        if(value) {
          
          this.choosePage = '1'
          this.pageList = this.pageListPop

          this.inspLoc = ''
          this.inspLocList =[]

          this.blockYn = false
          this.setPorNoseq = ''
         /*  this.window = {
            w: 0,
            h: 0,
            hDx: 0
          } */

          this.gridMainInstance.option('defaultPaging', false)

          if(this.popupData.qmPart === 'P' && (this.popupData.makerCd != '90263' || this.popupData.makerCd != '92699')){
            this.blockYn = true
            this.setPorNoseq = "POR NO"
          } else {
            this.blockYn = false
            this.setPorNoseq = "POR NO SEQ"
          }

          this.getList()
          this.doSearchMain()

          window.addEventListener('resize', this.handleResize);
          window.removeEventListener('resize', this.handleResize);
          this.handleResize();
          
        }
      },
      immediate: true
    }
  },

  mounted(){
    window.addEventListener('resize', this.handleResize);    
    this.handleResize();
    // this.gridMainInstance.option('defaultPaging', false)

    // if(this.popupData.qmPart === 'P' && (this.popupData.makerCd != '90263' || this.popupData.makerCd != '92699')){
    //   this.blockYn = true
    //   this.setPorNoseq = "POR NO"
    // } else {
    //   this.blockYn = false
    //   this.setPorNoseq = "POR NO SEQ"
    // }

    // this.getList()
    // this.doSearchMain()
  },

  // created() {
  //   window.addEventListener('resize', this.handleResize);
  //   this.handleResize();
  // },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.widths    = window.innerWidth - 100;
      this.window.heights   = window.innerHeight - 100;
      this.window.heightDx  = window.innerHeight - 380;
    },
    onHidden(e) {
      this.$emit('update:printPop', false)
    },
    async getList(){

      let param = {
        code: '',
        codegr: '',
        prtCode: 'INSP_LOC2',
        userFlag: 'Y'
      }

      await getCmChildCode(param).then(res => {
        this.inspLocList.push({code: '%' , codeName: 'All'})
        res.list.forEach(e => {
          this.inspLocList.push(e)
        });
        this.inspLoc = this.inspLocList[0]

        // this.inspLocList = res.list
        // this.inspLoc = res.list[0]
      })
    },
    async doSearchMain(){
      this.gridMainList = []
      this.totalRow = 0

      let params = {
        inspDiv: this.popupData.inspDiv,
        stDte: this.popupData.stDte,
        makerCd: this.popupData.makerCd,
        shipNo: this.popupData.shipNo,
        qmPart: this.popupData.qmPart,
        insRes: this.popupData.insRes,
        itemInfo: this.popupData.itemInfo,
        attendInsp: this.popupData.attendInsp,
        kindCd: this.popupData.kindCd,
        inspLoc: !this.inspLoc.code ? '' : this.inspLoc.code,
        pageNum: this.choosePage,
      }
      try {
        this.openLoading('searching')
        await v80oPrintList(params).then(res => {
          if(res.list.length){
            let cnt = 1
            res.list.forEach(e => {
              e.no = cnt
              e.id = cnt++
              // e.porNoSeq = e.porNo + '-' + e.porSeq
              if (e.qmPart == 'P' && ((e.makerCd !== "90263")||(e.makerCd !== "92699")) ) {
                e.porNoSeq = e.porNo + '-' + e.porSeq
              }else{
                e.porNoSeq = e.porNo
              }
            });
            this.gridMainList = res.list
            this.totalRow = res.list.length
          }
        })
      } finally {
        this.endLoading()
      }
    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }else if (e.rowType === 'header') {
        if (e.column.caption === 'POR NO') {
          e.cellElement.innerText = this.setPorNoseq;
        }
      }
    },
    choosePageChange(e){
      this.vToastifyPrompt(
          this.$t('Do you want to preview before Print sheet press OK!. Press Cancel to retrieve data!'),
          'info',
          current => {
            this.btnPrintSheet()
          },
          current => {
            this.doSearchMain()
          },
          true
      )
    },
    btnPrintSheet(){
      let gbn = ''
      if(this.popupData.qmPart == 'P'){
        if(this.popupData.makerCd === '13443'){
          gbn = 'v80o1020_prt_app_pnt_13443.jrxml'
        }else if(this.popupData.makerCd === '90263'){
          gbn = 'v80o1020_prt_app_pnt_90263.jrxml'
        }else if(this.popupData.makerCd === '92699'){
          gbn = 'v80o1020_prt_app_pnt_92699.jrxml'
        }else {
          gbn = 'v80o1020_prt_app_pnt.jrxml'
        }
      }else {
        if(this.popupData.makerCd === '90263' || this.popupData.makerCd === '92699'){
          gbn = 'v80o1020_prt_app_new.jrxml'
        }else if(this.popupData.makerCd === '14017' || this.popupData.makerCd === '12994'){
          gbn = 'v80a1040.jrxml'
        }else {
          gbn = 'v80o1020_prt_app.jrxml'
        }
      }
      const param = {
        fileName: gbn,
        as_cust_cd: this.popupData.makerCd,
        as_qm_part: this.popupData.qmPart,
        as_ship_no: this.popupData.shipNo,
        as_st_date: this.popupData.stDte,
        as_insp_div: this.popupData.inspDiv,
        as_item_info: !this.popupData.itemInfo,
        as_attend_insp: this.popupData.attendInsp,
        as_kind_cd: this.popupData.kindCd,
        as_insp_loc: !this.inspLoc.code ? '' : this.inspLoc.code,
        as_page_num: this.choosePage,
        as_ins_res: this.popupData.insRes
      }
      this.openLoading('searching')
      reportView(param)
          .finally(() => {
            this.endLoading()
          })
    }
  },
}
</script>

<style lang="scss" scoped>

</style>